import { render } from "./stage.vue?vue&type=template&id=5af00af2&scoped=true&ts=true"
import script from "./stage.vue?vue&type=script&lang=ts"
export * from "./stage.vue?vue&type=script&lang=ts"

import "./stage.vue?vue&type=style&index=0&id=5af00af2&lang=less&scoped=true"
import "./stage.vue?vue&type=style&index=1&id=5af00af2&lang=less&scoped=true"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af00af2"]])

export default __exports__